import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js

const EditCategory = () => {
    const { id } = useParams(); // Get the category ID from the URL
    const navigate = useNavigate();

    // State for holding the category data
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');

    // Fetch category details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}categories/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setName(data.data.name);
                    setImagePreview(`${BASE_URL}${data.data.image}`);
                }
            })
            .catch(error => console.error('Error fetching category details:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('name', name);
        if (image) {
            formData.append('image', image);
        }

        fetch(`${BASE_URL}categories/${id}`, {
            method: 'PUT',
            headers: {
                // No need to set 'Content-Type' as 'FormData' sets it automatically
            },
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert("Category updated successfully!");
                    navigate('/CategoriesList'); // Redirect to categories list
                } else {
                    alert("Error updating category. Please try again.");
                }
            })
            .catch(error => console.error('Error updating category:', error));
    };

    // Handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file)); // Show preview of the selected image
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Category</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Category Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header"></div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Category Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter category name"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Category Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleImageChange}
                                        />
                                        {imagePreview && (
                                            <div className="mt-3">
                                                <img src={imagePreview} alt="Category Preview" width="100" height="100" />
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Category</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Category Form */}
        </div>
    );
};

export default EditCategory;
